import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Lista o catálogo de tipos de corpo de prova do cliente da sessão.
// AJUSTE BACKEND AQUI: a listagem precisa devolver os tipos natos (catálogo padrão, sem idCliente)
// somados aos do cliente informado — hoje o filtro por idCliente esconderia os natos.
export const getTipoCorpoProva = async (idCliente) => {
	const effectiveClientId = idCliente || getSessionClientId();
	return await request(`/api/tipoCorpoProva?idCliente=${effectiveClientId}`);
};

// Cria um tipo de corpo de prova vinculado ao cliente da sessão.
export const createTipoCorpoProva = async (tipoCorpoProvaData) => {
	return await request('/api/tipoCorpoProva', {
		method: 'POST',
		body: JSON.stringify({ ...tipoCorpoProvaData, idCliente: getSessionClientId() }),
	});
};

// Atualiza um tipo de corpo de prova por id.
export const updateTipoCorpoProva = async (idTipoCorpoProva, tipoCorpoProvaData) => {
	return await request(`/api/tipoCorpoProva/${idTipoCorpoProva}`, {
		method: 'PUT',
		body: JSON.stringify({ ...tipoCorpoProvaData, idCliente: getSessionClientId() }),
	});
};

// Exclui um tipo de corpo de prova por id.
export const deleteTipoCorpoProva = async (idTipoCorpoProva) => {
	return await request(`/api/tipoCorpoProva/${idTipoCorpoProva}`, {
		method: 'DELETE',
	});
};